import {guyouRaw} from "../guyou.js";
import quincuncial from "./index.js";

export default function() {
  return quincuncial(guyouRaw)
      .scale(111.48);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo-projection/src/quincuncial/peirce.js
// module id = 285
// module chunks = 0